import { Box, Card, Stack, Step, StepContent, StepLabel, Stepper, CircularProgress, Typography } from "@mui/material"
import { useOutletContext } from "react-router-dom";
import { Project } from "../../../../types/entitys/project";
import { BoxSpanStyle, CardStyle, StepLabelStyle } from "./style";
import { useGetProjectStepsQuery } from "../../../../api";
import { NotFound } from "../../../ui-kit/NotFound";
import { formatStepDateForForm } from "../../../../pages/Profile/EditProject/Tabs/EditActionPlanForm/helpers/projectStepFormMappers";
import type { IProjectStepResource } from "../../../../api/types";

export const ActionPlan = () => {
    const project = useOutletContext<Project>();
    const { data: projectSteps, isLoading, isError } = useGetProjectStepsQuery({ slugOrId: project.id ?? '' });
    const formatStepDateRangeForView = (startedAt: string | null, finishedAt: string | null): string => {
        const from = formatStepDateForForm(startedAt)
        const to = formatStepDateForForm(finishedAt)
        if (!from && !to) return ""
        if (!from) return to
        if (!to) return from
        return `${from}-${to}`
    }

    const formatResponsibleNames = (responsibles: IProjectStepResource["responsibles"]): string => {
        const names = (responsibles ?? [])
            .map((user) => user.shortname?.trim())
            .filter(Boolean)

        return names.length > 0 ? names.join(", ") : "не назначены"
    }

    if (isLoading) {
        return (
            <Stack alignItems="center" justifyContent="center" minHeight="100%">
                <CircularProgress />
            </Stack>
        )
    }
    
    if (isError || !projectSteps) return <NotFound text={'Шаги плана действий не найдены'} />

    return (
        <>
            {projectSteps.length > 0 ? (<Card variant="primaryAdaptiveCard" sx={CardStyle}>
                <Stepper activeStep={project.action_plan_index - 1} orientation="vertical">
                    {projectSteps.map((step) => (
                        <Step 
                            key={step.id} 
                            expanded={true} 
                            sx={{overflowWrap: "anywhere"}}
                        >
                            <StepLabel sx={StepLabelStyle}>{step.name}</StepLabel>
                            <StepContent>
                                <Stack direction="column">
                                    <Typography variant="black-12-light">
                                        {formatStepDateRangeForView(step.started_at, step.finished_at)}
                                    </Typography>
                                    <Typography variant="black-12-light">{step.description}</Typography>
                                    <Typography variant="black-14-light">
                                        Ответственные: <Box component="span" sx={BoxSpanStyle}>{formatResponsibleNames(step.responsibles)}</Box>
                                    </Typography>
                                </Stack>
                            </StepContent>
                        </Step>
                    ))}
                </Stepper>
            </Card>) : (
                <NotFound text={'Шаги плана действий не найдены'} />
            )}
        </>
    )
}
